module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-header",
    style: ({
      backgroundColor: _vm.event.color
    })
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('v-touch', {
    staticClass: "no-desktop",
    on: {
      "tap": _vm.close
    }
  }, [_c('div', {
    staticClass: "font-large close-tap"
  }, [_c('span', {
    staticClass: "icon-cross2 pointer"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-large no-mobile close-tap",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2 pointer"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-body"
  }, [_c('div', {
    staticClass: "d-show-event__header__do-warning__container"
  }, [(_vm.event && _vm.event.canceled) ? _c('div', {
    staticClass: "d-show-event__header__do-warning do-warning do-warning--canceled"
  }, [_c('span', {
    staticClass: "icon-notification22"
  }), _vm._v("\n          " + _vm._s(_vm.i18n.canceled) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.event && _vm.event.away) ? _c('div', {
    staticClass: "d-show-event__header__do-warning do-warning"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n.out_of_school))]) : _vm._e()]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.event.index))]), _vm._v(" "), _c('section', {
    staticClass: "dialog-body"
  }, [_c('div', {
    staticClass: "dialog-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.event.title))])])]), _vm._v(" "), _c('section', {
    staticClass: "dialog-body"
  }, [_c('div', {
    staticClass: "dialog-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.dayAndDate))])])]), _vm._v(" "), _c('section', {
    staticClass: "dialog-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dialog-text"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("LT")(_vm.event.start)) + " - " + _vm._s(_vm._f("LT")(_vm.event.end)))]), _vm._v(" "), _c('span', [_vm._v("(\n            "), (_vm.eventHours >= 1) ? _c('span', [_vm._v(_vm._s(_vm.eventHours) + " " + _vm._s(_vm.eventHours > 1 ? _vm.$t('calendars.subject_hours.timer') : _vm.$t('repitition.hour')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.eventMinutes >= 1) ? _c('span', [_vm._v(_vm._s(_vm.eventMinutes + ' min'))]) : _vm._e(), _vm._v("\n          )")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog__dialog-body"
  }, [_c('ul', [(_vm.event.group) ? _c('li', {
    staticClass: "pad-15-0 border-bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dialog-text"
  }, [_c('b', [_vm._v(_vm._s(_vm.event.group))])])]) : _vm._e(), _vm._v(" "), (_vm.event.teacher) ? _c('li', {
    staticClass: "pad-15-0 border-bottom"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "dialog-text"
  }, [_c('b', [_vm._v(_vm._s(_vm.event.teacher))])])]) : _vm._e(), _vm._v(" "), (_vm.event.room) ? _c('li', {
    staticClass: "pad-15-0 border-bottom"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "dialog-text"
  }, [_c('b', [_vm._v(_vm._s(_vm.event.room))])])]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.learning_goal)) ? _c('li', {
    staticClass: "pad-15-0 border-bottom"
  }, [_c('div', {
    staticClass: "dialog-text marg-10-bottom"
  }, [_c('b', {
    style: ({
      color: _vm.event.color
    })
  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-text__content",
    domProps: {
      "innerHTML": _vm._s(_vm.event.learning_goal)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.description)) ? _c('li', {
    staticClass: "pad-15-0 border-bottom"
  }, [_c('div', {
    staticClass: "dialog-text marg-10-bottom"
  }, [_c('b', {
    style: ({
      color: _vm.event.color
    })
  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-text__content",
    domProps: {
      "innerHTML": _vm._s(_vm.event.description)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.notes_for_students)) ? _c('li', {
    staticClass: "pad-15-0 border-bottom"
  }, [_c('div', {
    staticClass: "dialog-text marg-10-bottom"
  }, [_c('b', {
    style: ({
      color: _vm.event.color
    })
  }, [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-text__content",
    domProps: {
      "innerHTML": _vm._s(_vm.event.notes_for_students)
    }
  })]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-icon"
  }, [_c('span', {
    staticClass: "icon-clock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-icon",
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_c('span', {
    staticClass: "icon-calendar4"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-icon"
  }, [_c('span', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-icon"
  }, [_c('span', {
    staticClass: "icon-location"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e8ebce4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/ShowEvent.vue
// module id = 1592
// module chunks = 1